import { useI18n } from '@change-corgi/core/react/i18n';

import { useLoginState } from 'src/app/shared/hooks/session';

import { usePromoteFormState } from '../../../../../../formContext';
import { useTracking } from '../../../../../../shared/hooks';

type Result = ModelHookResult<
	{
		name: string;
		firstName: string;
		lastName: string;
		validationErrors: Record<string, string> | null;
		useSplitFields: boolean;
		labelName: string;
		labelFirstName: string;
		labelLastName: string;
	},
	{
		setName: (name: string) => void;
		setFirstName: (firstName: string) => void;
		setLastName: (lastName: string) => void;
		trackNameInputFocus: () => void;
		trackFirstNameInputFocus: () => void;
		trackLastNameInputFocus: () => void;
	}
>;

export function useNameInputWrapper(): Result {
	const [{ name, firstName, lastName, validationErrors }, { setName, setFirstName, setLastName }] =
		usePromoteFormState();
	const { trackNameInputFocus, trackFirstNameInputFocus, trackLastNameInputFocus } = useTracking();
	const loginState = useLoginState();
	const { translate } = useI18n();
	const isGuest = loginState === 'GUEST';

	return {
		data: {
			name,
			firstName,
			lastName,
			validationErrors,
			useSplitFields: isGuest,
			labelName: translate('fe.components.credit_card.cardholder_name'),
			labelFirstName: translate('fe.components.credit_card.first_name'),
			labelLastName: translate('fe.components.credit_card.last_name'),
		},
		actions: {
			setName,
			setFirstName,
			setLastName,
			trackNameInputFocus,
			trackFirstNameInputFocus,
			trackLastNameInputFocus,
		},
	};
}
